import toast from "react-hot-toast";
import { ALPHABETS, baseServiceUrl, urls, EUserType } from "../environment";
import {
  QuestionBankTypes,
  QuestionResponseTypes,
} from "../interfaces/question.interface";

import { useRestService } from "../hooks/useRestService";

import { QuestionContextProps } from "../types/QuestionContextTypes";
import useQuestionStore from "../stores/useQuestionStore";
import useUserDataStore from "../stores/useUserDataStore";
import useAppLevelStores from "../stores/useAppLevelStores";

const useQuestionsService = (): QuestionContextProps => {
  const restService = useRestService(baseServiceUrl);
  const userDetails: any = useUserDataStore();
  const appLevelContext = useAppLevelStores();
  const questionStore = useQuestionStore();

  const initQuestionsService = () => {
    if (
      userDetails &&
      userDetails?.userdetail &&
      userDetails.userdetail?.userType === EUserType.CENTRALADMIN &&
      !!userDetails?.token
    ) {
      try {
        appLevelContext.setIsLoading(true);

        (async () => {
          const response = await restService.get(urls.uniqueQuestionBankURL);
          // const response = await axios.get(
          //   baseServiceUrl + urls.uniqueQuestionBankURL,
          //   {
          //     headers: {
          //       Authorization: "Bearer " + userDetails.token,
          //     },
          //   }
          // );
          if (response.data) questionStore.setQBankListing(response.data);
        })();
      } catch (err: any) {
        toast.error(
          err?.response?.data?.message || "Error encounter. Please try again.."
        );
      } finally {
        appLevelContext.setIsLoading(false);
      }
    }
  };

  //  *****************************  GET QUESTION LIST BY DEFAULT ACTION  *************************************  //
  const getQuestionListByDefaultAction = async (payload: any) => {
    try {
      appLevelContext.setIsLoading(true);
      const responseDetails = await restService.post(
        urls.getQuestionUrl,
        payload
      );

      if (responseDetails.data) {
        const questionResp = responseDetails.data?.resp?.map(
          (item: any, index: any) => ({
            question: `${item.ques.question}`,
            image: item.ques.image,
            marks: item?.ques?.marks,
            complexity: item?.ques?.complexity_value,
            language: item?.ques?.question_language_value,
            negetive_mark: item.ques.negetive_mark,
            subject: item.ques.question_type_value,
            options: item.ans.map((o: any, i: number) => ({
              val:
                "(" + ALPHABETS[i].toUpperCase() + ")" + " " + o.anwser_field,
              iscorrect: o.correct_flag,
              image: o.image,
            })),
            extra: item,
            id: item.ques.id,
          })
        );
        questionStore.setQuestionListing({
          page_index: responseDetails.data.page_index,
          page_size: responseDetails.data.page_size,
          total_count: responseDetails.data.total_count,
          resp: questionResp,
        });
      }
    } catch (error: any) {
      // toast.error(error?.response.message)
    } finally {
      appLevelContext.setIsLoading(false);
    }
  };

  const resetQuestionContext = () => {
    questionStore.setQBankListing([]);
    questionStore.setQuestionListing({
      page_index: 0,
      page_size: 0,
      resp: [],
      total_count: 0,
    });
  };

  return {
    getQuestionListByDefaultAction,
    resetQuestionContext,
    initQuestionsService,
  };
};

export default useQuestionsService;
